import PropTypes from "prop-types";
import {createNotification} from "app/actions/notifications";
import {destroy as destroyRecord} from "app/requests/admin/case-submissions";
import useAppContext from "lib/hooks/use-app-context";
import {displayDate} from "lib/string";

function AdminCaseSubmissionsListRow({record, onDestroy}) {
  const {dispatch} = useAppContext();
  const onDelete = () => {
    if(!window.confirm("Are you sure you want to delete this submission?")) { return; }

    destroyRecord(record.id).then(({message, success}) => {
      dispatch(createNotification({content: message, type: success ? "success" : "danger"}));

      if(success) { onDestroy(record.id); }
    });
  };

  return (
    <tr>
      <td>
        {record.user_id ? (
          <>
            <a href={`/admin/users/${record.user_id}`}>{record.first_name} {record.last_name}</a> ({record.email})
          </>
        ) : (
          `${record.first_name} ${record.last_name} (${record.email})`
        )}
      </td>
      <td>{record.title}</td>
      <td>{displayDate(record.created_at)}</td>
      <td>
        <div className="btn-group" role="group" aria-label="Actions">
          <a className="btn btn-sm btn-primary" href={`/admin/case-submissions/${record.id}`}>View</a>
          {record.case ? (
            <a className="btn btn-sm btn-success" href={`/admin/cases/${record.case.uid}`}>View Case</a>
          ) : (
            <a className="btn btn-sm btn-warning" href={`/admin/cases/new?case_submission_id=${record.id}`}>Create Case</a>
          )}
          <button className="btn btn-sm btn-danger" onClick={onDelete} type="button">Destroy</button>
        </div>
      </td>
    </tr>
  );
}

AdminCaseSubmissionsListRow.propTypes = {
  onDestroy: PropTypes.func.isRequired,
  record: PropTypes.shape({
    case: PropTypes.shape({uid: PropTypes.string.isRequired}),
    created_at: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    user_id: PropTypes.number
  }).isRequired
};

export default AdminCaseSubmissionsListRow;
